// ABOUTME: This component displays the SNP-level multi-endpoint Manhattan plot viewer in an iframe.
// ABOUTME: It loads a Panel app for comparing SNP-level associations across phenotypes in a targeted region.

import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserAuthService } from '../../services/user-auth.service';
import { environment } from '../../../environments/environment';
import { StudyFamily } from '../../interfaces/i-datasets';
import { navFor } from '../../study-families';

@Component({
  selector: 'app-snp-level-multi',
  templateUrl: './snp-level-multi.component.html',
  styleUrl: './snp-level-multi.component.scss',
})
export class SnpLevelMultiComponent implements OnInit {
  /** Bound from the route's `data.family` via bindToComponentInputs. */
  @Input() family: StudyFamily = 'gwas16';

  plotEndpoint: string = environment.baseUrl + 'manhattan/plot-multi';
  plotSrc: SafeResourceUrl | undefined;
  isLoading = true;

  constructor(
    public auth: UserAuthService,
    public sanitize: DomSanitizer,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadPlot();
  }

  loadPlot() {
    // study_family selects which multi-endpoint Bokeh app the backend serves. Sent for every
    // family, not just v3: the backend defaults to gwas16, so omitting it would work only by
    // accident and the URL would not say which study it is asking for.
    this.plotSrc = this.sanitize.bypassSecurityTrustResourceUrl(
      this.plotEndpoint +
        '?token=' +
        this.auth.getToken() +
        '&study_family=' +
        this.family,
    );
    this.isLoading = false;
  }

  goBack(): void {
    this.router.navigate([navFor(this.family).baseRoute]);
  }
}
